import AlertTriangleIcon from "@redotech/redo-icons/alert-triangle.svg";
import MarkerPinIcon from "@redotech/redo-icons/marker-pin-01.svg";
import PackageIcon from "@redotech/redo-icons/package.svg";
import ShieldTickIcon from "@redotech/redo-icons/shield-tick.svg";
import ShoppingBagIcon from "@redotech/redo-icons/shopping-bag-01.svg";
import ShoppingCartIcon from "@redotech/redo-icons/shopping-cart-01.svg";
import TrendUpIcon from "@redotech/redo-icons/trend-up-01_filled.svg";
import UserIcon from "@redotech/redo-icons/user-01.svg";
import { TriggerCategory } from "@redotech/redo-model/shopper-agent/trigger-definition";
import type { TreeIconComponent } from "@redotech/redo-web/arbiter-components/navigation/folder-tree/types";

export const shopperAgentTriggerCategoryOrder: TriggerCategory[] = [
  TriggerCategory.CART_CHECKOUT,
  TriggerCategory.SIGNUPS,
  TriggerCategory.PRODUCT_INTEREST,
  TriggerCategory.RETURNS_WARRANTY,
  TriggerCategory.ORDER_LIFECYCLE,
  TriggerCategory.SHIPPING_UPDATES,
  TriggerCategory.SHIPPING_ISSUES,
  TriggerCategory.PICKUP,
];

export const shopperAgentTriggerCategoryUi: Record<
  TriggerCategory,
  { friendlyName: string; Icon: TreeIconComponent }
> = {
  [TriggerCategory.CART_CHECKOUT]: {
    friendlyName: "Cart & checkout",
    Icon: ShoppingCartIcon,
  },
  [TriggerCategory.SIGNUPS]: { friendlyName: "Signups", Icon: UserIcon },
  [TriggerCategory.PRODUCT_INTEREST]: {
    friendlyName: "Product interest",
    Icon: TrendUpIcon,
  },
  [TriggerCategory.RETURNS_WARRANTY]: {
    friendlyName: "Returns & warranty",
    Icon: ShieldTickIcon,
  },
  [TriggerCategory.ORDER_LIFECYCLE]: {
    friendlyName: "Order lifecycle",
    Icon: ShoppingBagIcon,
  },
  [TriggerCategory.SHIPPING_UPDATES]: {
    friendlyName: "Shipping updates",
    Icon: MarkerPinIcon,
  },
  [TriggerCategory.SHIPPING_ISSUES]: {
    friendlyName: "Shipping issues",
    Icon: AlertTriangleIcon,
  },
  [TriggerCategory.PICKUP]: { friendlyName: "Pickup", Icon: PackageIcon },
};

export function getShopperAgentTriggerCategoryLabel(
  category: TriggerCategory,
): string {
  return shopperAgentTriggerCategoryUi[category].friendlyName;
}
